import React, { useEffect } from 'react';
import "./NoticiaDetalle.css";
import { useParams, Link } from 'react-router-dom';
import noticiasData from '../../data/noticias.json';

// Imágenes principales (portada / tarjeta)
import Noticia1Img from '../assets/images/landing/noticias/noticia-1.webp';
import Noticia2Img from '../assets/images/landing/noticias/noticia-2.webp';
import Noticia3Img from '../assets/images/landing/noticias/noticia-3.webp';
import Noticia4Img from '../assets/images/landing/noticias/noticia-4.webp';
import Noticia5Img from '../assets/images/landing/noticias/noticia-5.webp';
import Noticia6Img from '../assets/images/landing/noticias/noticia-6.webp';
import Noticia7Img from '../assets/images/landing/noticias/noticia-7.webp';

// Imágenes extra para el interior del texto
import Extra1Img from '../assets/images/landing/noticias/extra-1.webp';
import Extra2Img from '../assets/images/landing/noticias/extra-2.webp';
import Extra3Img from '../assets/images/landing/noticias/extra-3.webp';
import Extra4Img from '../assets/images/landing/noticias/extra-4.webp';
import Extra5Img from '../assets/images/landing/noticias/extra-5.webp';
import Extra6Img from '../assets/images/landing/noticias/extra-6.webp';
import Extra7Img from '../assets/images/landing/noticias/extra-7.webp';

const imagenesMap = {
  noticia1: Noticia1Img,
  noticia2: Noticia2Img,
  noticia3: Noticia3Img,
  noticia4: Noticia4Img,
  noticia5: Noticia5Img,
  noticia6: Noticia6Img,
  noticia7: Noticia7Img,
};

const imagenesExtraMap = {
  extra1: Extra1Img,
  extra2: Extra2Img,
  extra3: Extra3Img,
  extra4: Extra4Img,
  extra5: Extra5Img,
  extra6: Extra6Img,
  extra7: Extra7Img,
};

const imagenesEspecialesPC = ['extra5', 'noticia3', 'noticia4', "noticia5",'noticia2', 'extra4', 'extra6']; // Lista de imágenes que deben mostrarse completas en PC

const crearSlug = (texto) => {
  if (!texto) return '';
  return texto
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9 -]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

const NoticiaDetalle = () => {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  
  const noticia = noticiasData.find((n) => crearSlug(n.titulo) === slug);

  if (!noticia) {
    return (
      <div className="container my-5 text-center">
        <h3 className="text-secondary">Noticia no encontrada</h3>
        <p className="text-muted small">El enlace al que intentás acceder no coincide con ningún artículo disponible.</p>
        <Link to="/noticias/pagina/1" className="btn btn-primary mt-3" style={{ backgroundColor: '#334779', border: 'none' }}>
          Volver a noticias
        </Link>
      </div>
    );
  }

  // Verificamos si la imagen principal de esta noticia es especial
  const esImagenPrincipalEspecial = imagenesEspecialesPC.includes(noticia.imagenKey);

  return (
    <div className="container my-5" style={{ maxWidth: '800px' }}>
      <Link to="/noticias/pagina/1" className="btn btn-outline-secondary mb-4 btn-sm rounded-pill px-3">
        ← Volver a noticias
      </Link>

      <div className="mb-4">
        <span className="text-muted small">{noticia.tema}</span>
        <h1 className="fw-bold display-6 mt-1" style={{ color: '#334779' }}>{noticia.titulo}</h1>
      </div>

      {/* Imagen Principal de la Noticia */}
      <div className={`mb-4 rounded-3 overflow-hidden shadow-sm noticia-img-detalle-pc ${esImagenPrincipalEspecial ? 'contenedor-imagen-especial' : ''}`}>
        <img 
          src={imagenesMap[noticia.imagenKey]} 
          alt={noticia.titulo} 
          className={`w-100 noticia-img-real ${esImagenPrincipalEspecial ? 'imagen-especial-completa' : 'object-fit-cover'}`} 
        />
      </div>

      <div className="cuerpo-noticia">
        {noticia.contenido && noticia.contenido.map((bloque, index) => {
          if (bloque.tipo === 'parrafo') {
            return (
              <p 
                key={index} 
                className="text-secondary mb-4" 
                style={{ fontSize: '1.05rem', lineHeight: '1.7' }}
                dangerouslySetInnerHTML={{ __html: bloque.texto }}
              />
            );
          }

          if (bloque.tipo === 'imagen') {
            // Verificamos si esta imagen extra está en el listado especial
            const esImagenExtraEspecial = imagenesEspecialesPC.includes(bloque.url);

            return (
              <figure key={index} className="my-5 text-center">
                <div className={`rounded-3 overflow-hidden shadow-sm mb-2 noticia-img-detalle-pc ${esImagenExtraEspecial ? 'contenedor-imagen-especial' : ''}`}>
                  <img 
                    src={imagenesExtraMap[bloque.url]} 
                    alt={bloque.caption || 'Imagen interior'} 
                    className={`w-100 noticia-img-real ${esImagenExtraEspecial ? 'imagen-especial-completa' : 'object-fit-cover'}`} 
                  />
                </div>
                {bloque.caption && (
                  <figcaption className="text-muted small fst-italic">
                    {bloque.caption}
                  </figcaption>
                )}
              </figure>
            );
          }

          return null;
        })}
      </div>

      <div className="border-top pt-3 mt-5 text-muted small">
        <span>{noticia.fecha}</span>
      </div>
    </div>
  );
};

export default NoticiaDetalle;